"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _communication = require("../../../../icons-react/communication");
var CallSkeleton = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? 135 : _ref$height;
  return /*#__PURE__*/_react["default"].createElement(StyledItem, {
    className: className,
    $height: height
  }, /*#__PURE__*/_react["default"].createElement(StyledSkeletonIcon, null));
});
CallSkeleton.displayName = 'CallSkeleton';
var StyledItem = _styledComponents["default"].div.withConfig({
  displayName: "CallSkeleton__StyledItem",
  componentId: "sc-1a5bqc8-0"
})(["border-radius:4px;border:1px solid #919499;box-sizing:border-box;height:", ";padding:10px 9px;margin-bottom:10px;margin-right:10px;"], function (_ref2) {
  var $height = _ref2.$height;
  return "".concat($height, "px");
});
var StyledSkeletonIcon = (0, _styledComponents["default"])(_communication.CallSkeleton).withConfig({
  displayName: "CallSkeleton__StyledSkeletonIcon",
  componentId: "sc-1a5bqc8-1"
})(["width:207px;height:40px;animation:fade 0.1s ease;@keyframes fade{from{opacity:0;}}"]);
var _default = exports["default"] = CallSkeleton;